<div style="width: 100%; position:relative;">
  <div class="colored-scrollbar timelineScroll">
    <div class="timeline-ruler">
      <div class="rulerWrap col-xs-11 col-xs-offset-1">
        @for (ruler of rulerWidthList; track ruler) {
          <app-timeline-ruler
            height="50"
            [width]="ruler.width"
            [position]="ruler.pos"
            [scale]="timelineScale"
            [zoom]="timeLineState.zoom"
            [unitsTime]="true">
          </app-timeline-ruler>
        }
      </div>
    </div>
    <div class="timelineMain">
      <div class="timelineRow" (contextmenu)="onRightClickChannel($event)">

        <div class="channel-titles">
          @for (channel of timeLineState.channels; track channel; let i = $index) {
            <div class="channel-title"
              [class.channel-selected]="channel.selected"
              (click)="selectChannel(i)"
              [style.height.px]="timelineH">
              <span [title]="channel.label" class="channel-color" [style.backgroundColor]="channel.color"></span>
              <mat-icon [title]="channel.label">arrow_right</mat-icon>
            </div>
          }
        </div>

        <div class="timeline" (scroll)="onScroll($event)">
          <div id="playlistContainer">
            @for (item of timeLineState.items; track item; let i = $index) {
              <li class="box resizable draggable"
                [ngClass]="{'ui-selected': item.selected}"
                [attr.data-bid]="i"
                [style.width.px]="item.width"
                [style.height.px]="timelineH"
                [style.top.px]="item.top"
                [style.left.px]="item.left">
                <div class="li-item">
                  <div class="item-preview">
                    @if (item.pageType !== 'scene') {
                      <img [src]="item.pageSrc" style="height: 60px;" />
                    }
                    <!-- <ng-template #previewContainer></ng-template> -->
                    <!-- <ng-container *ngIf="item.pageType === 'scene' && scenePreviewRef.hostView">
                    <ng-container *ngTemplateOutlet="scenePreviewRef.hostView"></ng-container>
                  </ng-container> -->
                  @if (item.pageType === 'scene' && scenePreviewEnabled) {
                    <app-scene-preview
                      [setSelectedSceneId]="item.pageSrc"
                      [previewHeight]="60"
                      [autoScale]="true">
                    </app-scene-preview>
                  }
                  @if (item.pageType === 'scene' && !scenePreviewEnabled) {
                    <img src="./assets/images/empty_scene.png" style="height: 60px;" />
                  }
                </div>
                <div class="d-flex-center" style="margin: 3px;">
                  <mat-icon class="item-icon"> {{item.resource.src}}</mat-icon>
                  <span class="item-title">{{ item.title }}&nbsp;({{ formatDuration(item.duration) }})</span>
                </div>
              </div>
              @if (item.width > 100) {
                <a class="item-link" (click)="jumpToPlayer.next(item)">
                  <mat-icon>link</mat-icon>
                </a>
              }
            </li>
          }
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- <context-menu #contextMenuChannel>
<ng-template contextMenuItem (execute)="onClickPaste()">Paste</ng-template>
</context-menu> -->

<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
</div>

<mat-menu #contextMenu="matMenu" [overlapTrigger]="true" [hasBackdrop]="true" class="custom-context-menu">
  <ng-template matMenuContent>
    <button mat-menu-item disabled>
      <fa-icon class="fa-menu-icon" [icon]="faCut"></fa-icon>
      <span>{{'general.cut' | transloco}}</span>
    </button>
    <button mat-menu-item disabled>
      <fa-icon class="fa-menu-icon" [icon]="faCopy"></fa-icon>
      <span>{{'general.copy' | transloco}}</span>
    </button>
    <button mat-menu-item (click)="onClickPaste()">
      <fa-icon class="fa-menu-icon" [icon]="faPaste"></fa-icon>
      <span>{{'general.paste' | transloco}}</span>
    </button>
  </ng-template>
</mat-menu>

